import { Injectable } from '@angular/core';
import {
    ExpertiseAllowedStatusObject,
} from '@libs/types/src/services/object-type/service/expertise-allowed-status.object';
import { expertiseAllowedStatusFrag } from './types/expertise.types';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { ExpertisesGridObject } from '@it2go/types';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from './types/filter.types';

@Injectable({ providedIn: 'root' })
export class ExpertiseGqlServiceV2 extends GqlServiceV2 {

    public getExpertiseAllowedStatuses() {
        return this.query<ExpertiseAllowedStatusObject[]>(
            `
                query {
                    expertise {
                        allowedStatuses {
                            ${expertiseAllowedStatusFrag}
                        }
                    }
                }
            `,
        );
    }

    public getExpertises(input: GridInput, fragment: string) {
        return this.query<ExpertisesGridObject>(
            `
                query {
                    expertise {
                        filter {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
        );
    }

}
